import React, {useEffect, useState} from "react";
import axios from "axios";
import { useLocation, Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import moment from 'moment';
import { Button, Badge, Row, Col, Dropdown, Divider, Avatar, notification } from "antd";
import { Notification, TickSquare } from "react-iconly";
import { RiCloseFill } from "react-icons/ri";
import {MdNotificationsActive} from "react-icons/md";

const HeaderNotifications = () => {
  const direction = useSelector(state => state.customise.direction);

  const [notificationList, setNotificationList] = useState();
  const [NotificationCount, setNotificationCount] = useState(0);
  const token = localStorage.getItem("token").replace(/['"]+/g, '');
  const location = useLocation();

  const markAsSeen = (id) => { {
    axios.get(`https://internal.orevan-prox.com/notifications_api/mark_as_seen/${id}/`, { headers: {"Authorization" : `Token ${token}`} })  
    .then((res) => {
        getNotifcationRequest();
    })
    .catch((err) => {
      console.log(err);
    });
  }}

  const openSuccessNotification = (props) => {
    console.log(props)
    notification.open({
      message: "You have a notification!",
      description: `${props.title}`,
      icon: <MdNotificationsActive style={{ color: "#14b93a" }}/>,
      btn: (
        <Button
          type="primary"
          size="small"
          className="hp-btn-outline hp-text-color-success-1 hp-border-color-success-1 hp-hover-bg-success-1"
          onClick={() => markAsSeen(`${props.id}`)}
        >
          Mark as seen
        </Button>
      ),
      closeIcon: (
        <RiCloseFill className="remix-icon hp-text-color-black-80" size={24} />
      ),
    });
  };

  const getNotifcationRequest = () => {
    axios.get('https://internal.orevan-prox.com/notifications_api/', { headers: {"Authorization" : `Token ${token}`} })  
    .then((res) => {
      const data = JSON.parse(JSON.stringify(res.data));
      if( data.length > 0){
        setNotificationList(res.data.sort((a, b) => b.id - a.id))
      }
      let count = 0;
      for (let i = 0; i < data.length; i++) {
          if (!data[i].seen){
            openSuccessNotification({title:data[i].title, id:data[i].id})
            ++count
          }
      }
      setNotificationCount(count)
    })
    .catch((err) => {
      console.log(err);
    });
  }


  useEffect(() => {
      const interval = setInterval(() => {
        getNotifcationRequest()
      }, 240000);
      return () => clearInterval(interval);
  }, [location]);



  const notificationMenu = (
    <div className="hp-border-radius hp-border-1 hp-border-color-black-40 hp-bg-black-0 hp-bg-dark-100 hp-border-color-dark-80 hp-pt-24 hp-pb-18 hp-px-18 hp-mt-18" style={{ width: 288 }}>
      <Row align="middle" justify="space-between" className="hp-mb-18">
        <Col className="h5 hp-text-color-black-100 hp-text-color-dark-10 hp-text-color-dark-0 hp-mr-64">
          Notifications
        </Col>

        <Col className="hp-bg-color-primary-1 hp-border-radius-full hp-badge-text hp-text-color-black-0 hp-py-4 hp-px-6 hp-ml-24">
          {NotificationCount} New
        </Col>
      </Row>

      <Divider className="hp-my-4" />

      <div className="hp-overflow-y-auto hp-px-10" style={{ maxHeight: 300, marginRight: -10, marginLeft: -10 }}>
        {notificationList?.map((notification, i) =>(
          !notification.seen ?
            <div key={i} >
              <Link to={`../po-dashboard/invoice/${notification.url}`} onClick={() => markAsSeen(notification.id)}>
                <Row gutter={16} align="middle" className="hp-cursor-pointer hp-border-radius hp-transition hp-hover-bg-primary-4 hp-hover-bg-dark-80 hp-py-8 hp-px-10" style={{ marginLeft: -10, marginRight: -10 }}>
                  <Col lg={3} className="hp-mr-8 hp-p-0" >
                    <Avatar
                      size={38}
                      icon={<TickSquare size={16} className="hp-text-color-success-1" />}
                      className="hp-d-flex-center-full hp-bg-success-4"
                    />
                  </Col>
        
                  <Col lg={19} >
                    <span className="hp-d-block hp-w-100 hp-mb-4 hp-font-weight-500 hp-p1-body">
                      {notification.title}   
                    </span>
        
                    <span className="hp-d-block hp-badge-text hp-font-weight-400 hp-text-color-black-60 hp-text-color-dark-40">
                        {moment(
                          `${notification.date}`,
                        ).format('MMM Do YYYY, h:mm a')}
                  </span>
                  </Col>
                </Row>
              </Link>
    
              <Divider className="hp-my-4" />
            </div>
          :
            null
        ))}
      </div>


      <Button
        type="link"
        href="/notification-list"
        block
        className="hp-text-color-primary-1 hp-text-color-dark-primary-2 hp-fill-primary-1 hp-fill-dark-primary-2 hp-hover-bg-primary-4 hp-hover-bg-dark-80 hp-mt-4"
        icon={
          <i className="ri-more-fill hp-mr-10 ri-2x" />
        }
      >
        View More
      </Button>
    </div >
  );


  return (
    <Col className="hp-d-flex-center hp-mr-sm-12 hp-mr-16">
      <Button
        type="text"
        icon={
          <Dropdown overlay={notificationMenu} placement="bottomRight">
            <div className="hp-position-relative">
              <div className="hp-position-absolute" style={direction == "rtl" ? { left: -5, top: -5 } : { right: -5, top: -5 }}>
                { NotificationCount > 0 &&
                  <Badge
                    dot
                    status="processing"
                  />
                }
              </div>

              <Notification
                set="curved"
                className="hp-text-color-black-60"
              />
            </div>
          </Dropdown>
        }
      />
    </Col>


  );
};

export default HeaderNotifications;
